// extracted by mini-css-extract-plugin
module.exports = {"textIcon":"gou4_eq"};